import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Tooltip,
  IconButton,
  //FormControlLabel,
  //Switch,
  Stack,
  //Divider,
  Fade,
  Button,
} from "@mui/material";
import {
  //Notes,
  //PaletteOutlined,
  FormatPaint,
  Description,
} from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Header from "./components/Header.jsx";
import Logo from "./components/Logo";
import Footer from "./components/Footer";
import GlobalStylesEditor from "./globalStylesSection/GlobalStylesEditor";
import ColorPickerModal from "./ColorPickerModal.tsx";
//import { AVAILABLE_FONTS, AVAILABLE_POSITIONS } from "./globalStylesSection/constants/styleDefaults";
//import FontControls from "./globalStylesSection/components/FontControls";
//import PositionControls from "./globalStylesSection/components/PositionControls";
import { WitnessConfigPanel } from "../../../components/panel/panelNotes/witnessConfig/WitnessConfigPanel.jsx";
import { DownloadWordDocumentModal } from "../../../components/panel/panelNotes/DownloadWordDocumentModal.jsx";
import { DocumentConfigPanel } from "./DocumentConfigPanel.jsx";

const ConfigurationContent = ({ token, idDocument, onBack, onSwitchTab, nameDocument, date }) => {
  const [colorModal, setColorModal] = useState({
    open: false,
    type: null,
    title: "",
    current: "#000000",
    onApply: null,
  });

  const openColorModal = (type, currentColor, onApply, title) => {
    setColorModal({
      open: true,
      type,
      title: title || "Seleccionar color",
      current: currentColor || "#000000",
      onApply,
    });
  };

  const closeColorModal = () => {
    setColorModal((prev) => ({ ...prev, open: false }));
  };

  //const [indexStyles, setIndexStyles] = useState({ active: false });
  const [wordModalOpen, setWordModalOpen] = useState(false);
  const [witnessAlignmentRequest, setWitnessAlignmentRequest] = useState(0);

 /* const handleIndexChange = (updates) => {
    setIndexStyles((prev) => ({ ...prev, ...updates }));
  };*/

  const handleNavigateToWitnessAlignment = () => {
    setWitnessAlignmentRequest((request) => request + 1);
  };

  return (
    <Fade in timeout={300}>
      <Box sx={{ maxWidth: "auto", mx: "auto" }}>
      <Stack spacing={4}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          gap={2}
          mb={4}
          mt={{ xs: -3, sm: -6 }}
          p={2}
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            borderBottom: "1px solid",
            borderColor: "divider",
            backgroundColor: "background.paper",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Tooltip title="Volver" arrow>
              <IconButton
                onClick={onBack}
                sx={{
                  backgroundColor: "primary.main",
                  color: "white",
                  "&:hover": { backgroundColor: "primary.dark" },
                  boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                }}
              >
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
            <Typography
              variant="h5"
              sx={{ fontWeight: 700, color: "text.primary", letterSpacing: 0.5 }}
            >
              Edición de estilos del documento
            </Typography>
          </Box>

          <Button
            variant="contained"
            color="success"
            onClick={() => setWordModalOpen(true)}
            startIcon={<Description />}
            sx={{ borderRadius: "12px" }}
          >
            Descargar
          </Button>
        </Box>

        <Header
          token={token}
          idDocument={idDocument}
          openColorModal={openColorModal}
        />

        <Logo token={token} idDocument={idDocument} />

{/*
        <Card sx={{ borderRadius: "16px", bgcolor: "#ffffff" }}>
          <CardContent sx={{ p: 4 }}>
            <Box display="flex" alignItems="center" gap={2} mb={3}>
              <Notes sx={{ fontSize: 20, color: "#1976d2" }} />
              <Typography variant="h6" fontWeight="bold">
                Índice
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" mb={3}>
              Configura el índice del documento: activación, fuente, color y
              posición.
            </Typography>
            <Stack spacing={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={indexStyles?.active || false}
                    onChange={(e) =>
                      handleIndexChange({ active: e.target.checked })
                    }
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": { color: "#1976d2" },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                        bgcolor: "#1976d2",
                      },
                    }}
                  />
                }
                label="Agregar índice"
              />
              {indexStyles?.active && (
                <>
                  <FontControls
                    font={indexStyles.font}
                    fontSize={indexStyles.fontSize}
                    fontWeight={indexStyles.fontWeight}
                    color={indexStyles.color}
                    fonts={AVAILABLE_FONTS}
                    onFontChange={(value) => handleIndexChange({ font: value })}
                    onFontSizeChange={(value) =>
                      handleIndexChange({ fontSize: value })
                    }
                    onFontWeightChange={(value) =>
                      handleIndexChange({ fontWeight: value })
                    }
                    onOpenColorPicker={() =>
                      openColorModal(
                        "index",
                        indexStyles?.color || "#000000",
                        (newColor) => handleIndexChange({ color: newColor }),
                        "Seleccionar color de texto"
                      )
                    }
                  />
                  <PositionControls
                    value={indexStyles?.position}
                    onChange={(value) => handleIndexChange({ position: value })}
                    label="Posición del índice"
                    positions={AVAILABLE_POSITIONS}
                  />
                  <Divider />
                  <Box>
                    <Typography variant="body2" color="text.secondary" mb={2}>
                      Color de la pleca
                    </Typography>
                    <Tooltip title="Seleccionar color de pleca">
                      <IconButton
                        size="small"
                        onClick={() =>
                          openColorModal(
                            "indexPleca",
                            indexStyles?.pleca || "#1976d2",
                            (newColor) => handleIndexChange({ pleca: newColor }),
                            "Seleccionar color de pleca"
                          )
                        }
                        sx={{
                          bgcolor: indexStyles?.pleca || "#1976d2",
                          borderRadius: "50%",
                          border: "1px solid #d1d5db",
                          width: 32,
                          height: 32,
                        }}
                      >
                        <PaletteOutlined sx={{ fontSize: 16, color: "white" }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </>
              )}
            </Stack>
          </CardContent>
        </Card>

*/}
        <Footer
          token={token}
          idDocument={idDocument}
          openColorModal={openColorModal}
        />

        <WitnessConfigPanel
          token={token}
          documentId={idDocument}
          alignmentNavigationRequest={witnessAlignmentRequest}
        />

        <DocumentConfigPanel token={token} idDocument={idDocument} />

        <Card sx={{ borderRadius: "16px", bgcolor: "#ffffff" }}>
          <CardContent sx={{ p: 4 }}>
            <Box display="flex" alignItems="center" gap={2} mb={3}>
              <FormatPaint sx={{ fontSize: 20, color: "#1976d2" }} />
              <Typography variant="h6" fontWeight="bold">
                Estilos Globales de Sección
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" mb={3}>
              Aplica estilos uniformes a todas las secciones del documento de
              forma global.
            </Typography>
            <GlobalStylesEditor
              token={token}
              documentId={idDocument}
              onSwitchTab={onSwitchTab}
              onNavigateToWitnessAlignment={handleNavigateToWitnessAlignment}
            />
          </CardContent>
        </Card>
      </Stack>

      <ColorPickerModal
        open={colorModal.open}
        title={colorModal.title}
        color={colorModal.current}
        onClose={closeColorModal}
        onApply={(newColor) => {
          if (colorModal.onApply) {
            colorModal.onApply(newColor);
          }
        }}
      />

      <DownloadWordDocumentModal
        token={token}
        open={wordModalOpen}
        close={() => setWordModalOpen(false)}
        documentData={{
          id_documento: idDocument,
          fecha: date,
          nombreDocumento: nameDocument,
        }}
      />
    </Box>
    </Fade>
  );
};

export default ConfigurationContent;
